import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { GeneralModalComponent } from './general-modal.component';

@NgModule({
    declarations: [GeneralModalComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule
    ]
})
export class GeneralModalModule { }
